export default __webpack_public_path__ + "static/wavy-background-180786598e741294f08ecaf1990ddc76.png";